'use strict';

let Marionette = require('backbone.marionette');
let Radio = require('backbone.radio');
let LanguageCollection = require('../collections/languages').default;
let LanguagePickerView = require('./language-picker/picker').default;

export default Marionette.View.extend({

  className: 'step-title',
  template: require('./templates/step-title.hbs'),
  events: {
    'click .step-title-back': 'onClickBack',
    'click #language': 'togglePicker',
  },
  regions: {
    toggle: '.l-step-title-toggle',
  },
  ui: {
    language: '#language',
    back: '.step-title-back',
    picker: '#language-picker',
    indicator: '#lang-dropdown-indicator',
  },

  initialize: function (options) {
    options = options || {};
    this.languages = new LanguageCollection(window.LANGUAGES);
    this.title = options.title || 'Title';

    this.listenTo(Radio.channel('windows'), 'close', this.onClosePicker);
  },

  serializeData: function () {
    return {
      languages: this.languages.toJSON(),
      title: this.title,
    };
  },

  onRender: function () {
    if (!Radio.channel('steps').request('enabled') || Radio.channel('steps').request('first')) {
      this.ui.back.css('visibility', 'hidden');
    }
    this.renderPicker();
  },

  renderPicker: function () {
    this.ui.picker.hide();
    //if no extra languages are set, the window.LANGUAGES array will only contain English (default),
    // and .:. we don't need to show the picker at all.
    if (this.languages.length <= 1) {
      this.ui.language.hide();
      this.ui.picker.hide();
      // while this *should* always be the default, this will cover the off-chance
      // that the current language was selected before it was disabled
      if(this.languages.getCurrent() !== 'en') {
        this.languages.setCurrent('en');
      }
    } else {
      let $indicator = this.ui.language.find('i');
      let $span = this.ui.language.find('span');
      this.ui.language.text(this.languages.getCurrent().toUpperCase());
      this.ui.language.prepend($indicator);
      this.ui.language.append($span);
    }
  },

  onClickBack: function (evt) {
    evt.preventDefault();
    Radio.channel('steps').trigger('click:back');
  },

  togglePicker: function (evt) {
    evt.preventDefault();
    if (this.ui.picker.is(':visible')) {
      this.hidePicker();
    } else {
      this.showPicker();
    }
    this.toggleIndicator();
  },

  showPicker: function () {
    if (this.ui.picker.is(':visible')) {
      this.ui.picker.hide();
    } else {
      var view = new LanguagePickerView({
        collection: this.languages,
      });
      this.ui.picker.html(view.render().el);
      this.ui.picker.show();
    }
  },

  hidePicker: function () {
    this.ui.picker.empty();
    this.ui.picker.hide();
  },

  onClosePicker: function () {
    this.hidePicker();
    this.toggleIndicator();
  },

  toggleIndicator: function () {
    if (this.ui.picker.is(':visible')) {
      this.ui.indicator.addClass('fa-chevron-up');
      this.ui.indicator.removeClass('fa-chevron-down');
      this.ui.language.attr('aria-expanded', 'true');
    } else {
      this.ui.indicator.addClass('fa-chevron-down');
      this.ui.indicator.removeClass('fa-chevron-up');
      this.ui.language.attr('aria-expanded', 'false');
    }
  },

});
